import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const AssignProviderAdditionalDocs = (apiData) => async () => {
  try {
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/provider/AssignProviderAdditionalDocs`,
      data: apiData,
    });
    return response.data;
  } catch (error) {
    return error?.response?.data || { success: false, message: error.message };
  }
};
